<template>
  <div>
    <v-btn id="Key_addr_back_btn" icon @click="closeModal">
      <v-icon>chevron_left</v-icon>
    </v-btn>

    <v-row no-gutters align="center">
      <span class="text-h6 context_title_color--text">
        {{ $tc('get_addr') }}
      </span>

      <span class="text-h5 font-weight-medium mx-1">
        {{ '/' }}
      </span>

      <svg
        class="mr-2"
        style="width: 24px; height: 24px"
        viewBox="0 0 24 24"
      >
        <path :fill="iconcolor" :d="svg" />
      </svg>

      <card-toolbar :title="name" class="mt-md-2" />
    </v-row>

    <v-row no-gutters align="center">
      <v-col cols="6" md="3">
        <span
          class="subtitle-1 font-weight-medium"
        >
          {{ this.$tc('type') }}
        </span>

        <p>
          {{ keyInfo.id }}
        </p>
      </v-col>

      <v-col v-if="kinfo" cols="6" md="3">
        <span
          class="subtitle-1 font-weight-medium"
        >
          {{ this.$tc('bchain_version') }}
        </span>

        <p>
          {{ this.$tc('yes') }}
        </p>

        <!-- <p>
          {{ kinfo.version === 1 ? this.$tc('yes') : this.$tc('no') }}
        </p> -->
      </v-col>

      <v-col v-if="kinfo && kinfo?.version === 1" cols="6" md="3">
        <span
          class="subtitle-1 font-weight-medium"
        >
          {{ this.$tc('x_depth') }}
        </span>

        <p>
          {{ kinfo.x_depth }}
        </p>
      </v-col>

      <v-col v-if="kinfo && kinfo?.version === 1" cols="6" md="3">
        <span
          class="subtitle-1 font-weight-medium"
        >
          {{ this.$tc('x_ver') }}
        </span>

        <p>
          {{ versionInfo(kinfo.x_ver) }}
        </p>
      </v-col>

      <v-col v-if="kinfo && kinfo?.version === 1" cols="6" md="3">
        <span
          class="subtitle-1 font-weight-medium"
        >
          {{ this.$tc('x_par_fp') }}
        </span>

        <p>
          {{ kinfo.x_par_fp }}
        </p>
      </v-col>

      <v-col v-if="kinfo && kinfo?.version === 1" cols="6" md="3">
        <span
          class="subtitle-1 font-weight-medium"
        >
          {{ this.$tc('x_child_num') }}
        </span>

        <p>
          <span>{{ parseInt(kinfo.x_child_num, 16) }}</span>
          <span>{{ '/' }}</span>
          <span class="subtitle-2 context_title_color--text">{{ '0x' + kinfo.x_child_num }}</span>
        </p>
      </v-col>
    </v-row>

    <div>
      <v-autocomplete
        id="get_addr_type"
        :label="$tc('type')"
        :items="typeOptions"
        item-text="name"
        item-value="option"
        v-model="type"
      />

      <v-autocomplete
        v-if="hasVersion"
        id="get_addr_version"
        :label="$tc('version')"
        :items="versionOptions"
        item-text="name"
        item-value="option"
        v-model="version"
      />

      <v-autocomplete
        v-if="hasHrp"
        id="get_addr_hrp"
        :label="$tc('hrp')"
        :items="hrpOptions"
        item-text="name"
        item-value="option"
        v-model="hrp"
      />

      <v-row no-gutters justify="end">
        <v-btn
          id="get_addr_submit"
          color="blue"
          :disabled="$v.$invalid"
          :dark="!$v.$invalid"
          @click="submit"
        >
          {{ $tc('get_addr') }}
        </v-btn>
      </v-row>

      <v-row no-gutters>
        <v-col cols="11">
          <v-textarea
            id="blockchain_export_outBlock"
            class="monospace"
            auto-grow
            row="6"
            row-height="25"
            label="Out Block"
            readonly
            v-model="outBlock"
          />
        </v-col>
        <v-col cols="1">
          <v-row no-gutters>
            <v-col cols="12">
              <!-- CLIPBOARD -->
              <v-tooltip left>
                <template #activator="{ on }">
                  <v-btn
                    id="blockchain_outBlock_clipboard"
                    icon
                    v-on="on"
                    class="my-1"
                    color="contrasty"
                    v-clipboard:copy="outBlock"
                  >
                    <v-icon>content_copy</v-icon>
                  </v-btn>
                </template>
                <span>{{ $tc("copy") }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12">
              <!-- SAVE -->
              <v-tooltip left>
                <template #activator="{ on }">
                  <v-btn
                    id="blockchain_outBlock_saveFile"
                    icon
                    v-on="on"
                    class="my-1"
                    color="contrasty"
                    @click="saveToFile(outBlock)"
                  >
                    <v-icon>save</v-icon>
                  </v-btn>
                </template>
                <span>{{ $tc("save_to_file") }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import CardToolbar from '@/components/CardToolbar'

const XPRIV_TEST_NET = '04358394'
const XPRIV_MAIN_NET = '0488ADE4'

const FPRIV = '03273A10'
const FPUB = '0488b21e'

const HATHOR_MAIN_NET = '03523b05'
const HATHOR_TEST_NET = '0434c8c4'

export default {
  components: {
    CardToolbar
  },
  created () {
    this.name = this.$route.params.name
    this.svg = this.$route.params.svg
    this.iconcolor = this.$route.params.iconcolor
    this.page = this.$route.params.page
    this.info = this.$route.params.info

    this.getBlockchainInfo()
  },
  data () {
    return {
      name: null,
      svg: null,
      iconcolor: null,
      page: 1,
      outBlock: null,
      hrp: null,
      type: null,
      version: null,
      info: null,
      kinfo: null
    }
  },
  computed: {
    hrpOptions () {
      const hrps = [
        // {
        //   name: 'Unused',
        //   option: ''
        // },
        {
          name: 'BTC main net',
          option: 'bc'
        },
        {
          name: 'BTC test net',
          option: 'tb'
        }
      ]

      return hrps
    },
    typeOptions () {
      const types = [
        {
          name: this.$tc('p2pkh'),
          option: 1
        },
        // {
        //   name: this.$tc('p2sh'),
        //   option: 2
        // },
        {
          name: this.$tc('bech32_pkh'),
          option: 3
        },
        // {
        //   name: this.$tc('bech32_sh'),
        //   option: 4
        // },
        {
          name: this.$tc('eth_eoa'),
          option: 5
        },
        {
          name: this.$tc('eth_eoa_mc_cks'),
          option: 6
        },
        {
          name: this.$tc('eth_eoa_icap'),
          option: 7
        },
        {
          name: this.$tc('algorand'),
          option: 8
        },
        {
          name: this.$tc('tron_hex'),
          option: 9
        },
        {
          name: this.$tc('tron_b58'),
          option: 10
        },
        {
          name: this.$tc('xrp'),
          option: 11
        },
        {
          name: this.$tc('sol'),
          option: 12
        }
      ]

      const typesForEd25519 = [
        // {
        //   name: this.$tc('p2sh'),
        //   option: 2
        // },
        // {
        //   name: this.$tc('bech32_sh'),
        //   option: 4
        // },
        {
          name: this.$tc('algorand'),
          option: 8
        },
        {
          name: this.$tc('xrp'),
          option: 11
        },
        {
          name: this.$tc('sol'),
          option: 12
        }
      ]

      const typesForXpriv = [
        {
          name: this.$tc('p2pkh'),
          option: 1
        },
        // {
        //   name: this.$tc('p2sh'),
        //   option: 2
        // },
        {
          name: this.$tc('bech32_pkh'),
          option: 3
        },
        // {
        //   name: this.$tc('bech32_sh'),
        //   option: 4
        // },
        {
          name: this.$tc('eth_eoa'),
          option: 5
        },
        {
          name: this.$tc('eth_eoa_mc_cks'),
          option: 6
        },
        {
          name: this.$tc('eth_eoa_icap'),
          option: 7
        },
        {
          name: this.$tc('tron_hex'),
          option: 9
        },
        {
          name: this.$tc('tron_b58'),
          option: 10
        },
        {
          name: this.$tc('xrp'),
          option: 11
        }
      ]

      const typesForSecp = [
        {
          name: this.$tc('p2pkh'),
          option: 1
        },
        // {
        //   name: this.$tc('p2sh'),
        //   option: 2
        // },
        {
          name: this.$tc('bech32_pkh'),
          option: 3
        },
        // {
        //   name: this.$tc('bech32_sh'),
        //   option: 4
        // },
        {
          name: this.$tc('eth_eoa'),
          option: 5
        },
        {
          name: this.$tc('eth_eoa_mc_cks'),
          option: 6
        },
        {
          name: this.$tc('eth_eoa_icap'),
          option: 7
        },
        {
          name: this.$tc('tron_hex'),
          option: 9
        },
        {
          name: this.$tc('tron_b58'),
          option: 10
        },
        {
          name: this.$tc('xrp'),
          option: 11
        }
      ]

      const typesForEd25519Xpriv = [
        // {
        //   name: this.$tc('p2sh'),
        //   option: 2
        // },
        // {
        //   name: this.$tc('bech32_sh'),
        //   option: 4
        // },
        {
          name: this.$tc('algorand'),
          option: 8
        },
        {
          name: this.$tc('xrp'),
          option: 11
        },
        {
          name: this.$tc('sol'),
          option: 12
        }
      ]

      switch (this.keyInfo.id) {
        case 'ed25519':
          return typesForEd25519

        case 'bip32ed25519xpriv':
          return typesForEd25519Xpriv

        case 'bip32xpriv':
          return typesForXpriv

        case 'secp256k1':
        case 'secp256r1':
          return typesForSecp

        default:
          return types
      }
    },
    versionOptions () {
      const versionsP2PKH = [
        {
          name: 'Bitcoin A1',
          option: 0x00
        },
        {
          name: 'Bitcoin A3',
          option: 0x05
        },
        {
          name: 'Bitcoin P2PKH',
          option: 0x6F
        },
        {
          name: 'Hathor mainnet',
          option: 0x28
        },
        {
          name: 'Hathor testnet',
          option: 0x49
        }
      ]

      const versionsP2SH = [
        {
          name: 'Bitcoin A1',
          option: 0x00
        },
        {
          name: 'Bitcoin A3',
          option: 0x05
        },
        {
          name: 'Bitcoin P2PKH',
          option: 0x6F
        },
        {
          name: 'Hathor mainnet',
          option: 0x28
        },
        {
          name: 'Hathor testnet',
          option: 0x49
        }
      ]

      const versionsBech32PKH = [
        {
          name: 'Bitcoin B32 Witver',
          option: 0x00
        }
      ]

      const versionsBech32SH = [
        {
          name: 'Bitcoin A1',
          option: 0x00
        },
        {
          name: 'Bitcoin A3',
          option: 0x05
        },
        {
          name: 'Bitcoin P2PKH',
          option: 0x6F
        },
        {
          name: 'Hathor mainnet',
          option: 0x28
        },
        {
          name: 'Hathor testnet',
          option: 0x49
        }
      ]

      const versionsXRP = [
        {
          name: 'XRP classic',
          option: 0x00
        }
      ]

      switch (this.type) {
        case 1:
          return versionsP2PKH

        case 2:
          return versionsP2SH

        case 3:
          return versionsBech32PKH

        case 4:
          return versionsBech32SH

        case 11:
          return versionsXRP

        default:
          return versionsP2PKH
      }
    },
    isBlockchainType () {
      const blockchainList = ['bip32xpriv', 'bip39sxpriv', 'bip32sxpriv', 'btcminikey', 'bip32ed25519xpriv']

      return blockchainList.includes(this.keyInfo.id)
    },
    keyInfo () {
      return this.$store.getters['keys/getKeyType']({
        type: this.info.type
      })
    },
    hasVersion () {
      const valuesOfTypesHasVersionAndHrp = [1, 2, 3, 4]

      return valuesOfTypesHasVersionAndHrp.includes(this.type)
    },
    hasHrp () {
      const bech32Pkh = 3

      return this.type === bech32Pkh
    }
  },
  validations () {
    const validation = {}

    const hrpSelected = value => {
      return value !== null
    }

    validation.type = {
      required
    }

    if (this.hasHrp) {
      validation.hrp = {
        hrpSelected
      }
    }

    if (this.hasVersion) {
      validation.version = {
        required
      }
    }

    return validation
  },
  methods: {
    versionInfo (version) {
      switch (version) {
        case XPRIV_TEST_NET:
        case HATHOR_TEST_NET:
          return this.$tc('test_net')

        case XPRIV_MAIN_NET:
        case HATHOR_MAIN_NET:
          return this.$tc('main_net')

        case FPRIV:
          return this.$tc('fpriv')

        case FPUB:
          return this.$tc('fpub')

        default:
          return version
      }
    },
    getBlockchainInfo () {
      return this.$store.dispatch('hsm/bchain_kinfo', {
        body: {
          key: this.name
        }
      })
        .then((res) => {
          this.kinfo = res
        })
        .catch((err) => {
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
    },
    saveToFile (res) {
      if (res) {
        const FileSaver = require('file-saver')
        const blob = new Blob([res], { type: 'text/plain;charset=utf-8' })

        const hrpName = this.hrpOptions.find(item => item.option === this.hrp).name.replace(/\s+/g, '')
        const versionName = this.versionOptions.find(item => item.option === this.version).name.replace(/\s+/g, '')
        const typeName = this.typeOptions.find(item => item.option === this.type).name.replace(/\s+/g, '')

        const fileName = this.name + hrpName + versionName + typeName + '.bin'
        FileSaver.saveAs(blob, fileName)
      }
    },
    closeModal () {
      this.$router.push(
        {
          name: 'partition-keys',
          query: {
            p: this.page
          }
        }
      )
    },
    submit () {
      if (!this.hasVersion) {
        const unusedVersion = 0x00
        this.version = unusedVersion
      }

      if (!this.hasHrp) {
        const unusedHrp = ''
        this.hrp = unusedHrp
      }
      this.$store.dispatch('hsm/bchain_get_addr', {
        body: {
          key: this.name,
          hrp: this.hrp,
          type: this.type,
          version: this.version
        }
      })
        .then((res) => {
          this.outBlock = res.addr
          this.$notify.success({})
        })
        .catch((err) => {
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
    }
  },
  watch: {
    type (val) {
      this.outBlock = null
    },
    version (val) {
      this.outBlock = null
    }
  }
}
</script>
